import { ArrowUp, ArrowDown, Clock, Briefcase, BarChart3, XCircle } from 'lucide-react';
import type { ActivityView, ActivityIcon } from '@/lib/walletActivity';
import { cn } from '@/lib/utils';

// SAB-565 pt2 v1: rows are NON-INTERACTIVE (decided deviation from the handoff's
// "tappable → detail view / hover lift / role=button" — no per-row detail in v1).
const ICONS: Record<ActivityIcon, typeof ArrowUp> = { ArrowUp, ArrowDown, Clock, Briefcase, BarChart3, XCircle };
const ICON_COLOR: Record<string, string> = {
  success: 'text-success', gold: 'text-gold', neutral: 'text-muted-foreground', damage: 'text-damage',
};
const TILE_BG: Record<string, string> = {
  success: 'hsl(160 84% 39% / 0.12)', gold: 'hsl(45 93% 47% / 0.12)', neutral: 'hsl(222 30% 16%)', damage: 'hsl(0 84% 60% / 0.12)',
};
const AMOUNT_COLOR: Record<string, string> = {
  success: 'text-success', gold: 'text-gold', damage: 'text-damage', fg: 'text-foreground', neutral: 'text-foreground',
};

export default function WalletActivityRow({ v, mobile = false }: { v: ActivityView; mobile?: boolean }) {
  const Icon = ICONS[v.icon];
  return (
    <div className={cn('flex items-center', mobile ? 'gap-3 px-[15px] py-[14px]' : 'gap-[14px] px-[18px] py-[15px]')}>
      <span
        className={cn('grid place-items-center shrink-0', mobile ? 'h-9 w-9 rounded-[10px]' : 'h-[38px] w-[38px] rounded-[11px]')}
        style={{ background: TILE_BG[v.tone] }}
      >
        <Icon className={cn(ICON_COLOR[v.tone], mobile ? 'h-[17px] w-[17px]' : 'h-[18px] w-[18px]')} strokeWidth={2} />
      </span>
      <span className="flex-1 min-w-0">
        <span className={cn('block font-semibold text-foreground truncate', mobile ? 'text-[14.5px]' : 'text-[15px]')}>{v.title}</span>
        <span className={cn('block text-muted-foreground mt-0.5', mobile ? 'text-[12px]' : 'text-[12.5px]')}>{v.meta}</span>
      </span>
      <span className={cn('font-display font-bold tabular-nums text-right shrink-0', mobile ? 'text-[15px]' : 'text-[16px]', AMOUNT_COLOR[v.amountTone])}>
        {v.amountText}
      </span>
    </div>
  );
}
